"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Group = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var colors_1 = require("../../../theme/colors");
var expandable_row_1 = require("../../expandable-row");
var text_1 = require("../../text");
function Group(props) {
    var children = props.children, _a = props.expanded, expanded = _a === void 0 ? false : _a, title = props.title;
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(expandable_row_1.ExpandableRow, { removeStyling: true, expanded: expanded },
            react_1.default.createElement(expandable_row_1.ExpandableHead, { isClickAnywhere: true, paddingX: 12, paddingY: 8, onExpandedBackgroundColor: "".concat(colors_1.colors.steel[100]), onCollapsedBackgroundColor: "".concat(colors_1.colors.steel[100]), alignItems: "center" },
                react_1.default.createElement(text_1.Text, { color: "light", weight: 600 }, title.toUpperCase())),
            react_1.default.createElement(expandable_row_1.ExpandableBody, { paddingX: 0, paddingBottom: 0 }, children))));
}
exports.Group = Group;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  border-bottom: 1px solid ", ";\n"], ["\n  border-bottom: 1px solid ", ";\n"])), colors_1.colors.steel[200]);
var templateObject_1;
//# sourceMappingURL=group.js.map